import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useCaseContext } from '../context/CaseContext';
import '../mobile.css';

const MobileTimeline = () => {
  const location = useLocation();
  const { fullFIR } = useCaseContext();
  const fir = location.state?.fir || fullFIR;
  const events = fir?.eventsAndTimeline || [];
  const [expandedIndex, setExpandedIndex] = useState(null);

  if (!fir) return <p style={{ textAlign: 'center', fontWeight: 700 }}>No case data available.</p>;
  if (events.length === 0) return <p style={{ textAlign: 'center', fontWeight: 700 }}>No timeline events found.</p>;

  return (
    <div>
      {events.map((event, index) => {
        const isOpen = expandedIndex === index;
        return (
          <div key={index} className="m-card" onClick={() => setExpandedIndex(isOpen ? null : index)} style={{ cursor: 'pointer' }}>
            <div style={{ fontSize: '14px', fontWeight: 700, color: '#094268', marginBottom: '6px' }}>
              {event.date}{event.time ? ` ${event.time}` : ''}
            </div>
            <div style={{ fontSize: '14px', fontWeight: 600, color: '#111', textAlign: 'justify' }}>{event.description}</div>

            {isOpen && (
              <>
                {event.location && <div style={{ marginTop: '6px', textAlign: 'justify' }}><b>Location: </b>{event.location}</div>}
                {Array.isArray(event.personsInvolved) && event.personsInvolved.length > 0 && (
                  <div style={{ marginTop: '6px', textAlign: 'justify' }}><b>Persons Involved: </b>{event.personsInvolved.join(', ')}</div>
                )}
                {event.source && <div style={{ marginTop: '6px', textAlign: 'justify' }}><b>Source: </b>{event.source}</div>}
              </>
            )}

            <div style={{ textAlign: 'right', marginTop: '8px', fontSize: '14px', fontWeight: 600, color: '#5B7CFF' }}>
              {isOpen ? 'Hide' : 'Show'}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MobileTimeline;
